import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API          = 'https://api.jsmstock.com'; // ⚠️ Your IP!
const ADMIN_SECRET = 'jsmstock-admin-2026-secret'; // ⚠️ Your secret!
const YOUR_UPI     = 'manikj729@oksbi'; // ⚠️ Your UPI!

const PLANS = {
  trial:    { name:'🆓 Trial',    color:'#888', bg:'#F0F0F0', price:0   },
  pro:      { name:'⭐ Pro',      color:'#3498DB', bg:'#EBF5FB', price:299 },
  premium:  { name:'👑 Premium',  color:'#C9A84C', bg:'#FFF9E6', price:599 },
  business: { name:'🏢 Business', color:'#9B59B6', bg:'#F3E5F5', price:999 },
};

function AdminDashboard({ onLogout }) {
  const [users,       setUsers]       = useState([]);
  const [blacklist,   setBlacklist]   = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [error,       setError]       = useState('');
  const [success,     setSuccess]     = useState('');
  const [search,      setSearch]      = useState('');
  const [filter,      setFilter]      = useState('all');
  const [activeTab,   setActiveTab]   = useState('users');
  const [stats,       setStats]       = useState({});
  const [showUpgrade, setShowUpgrade] = useState(false);
  const [upgradeUser, setUpgradeUser] = useState(null);
  const [upgradePlan, setUpgradePlan] = useState('premium');
  const [upgradePrice,setUpgradePrice]= useState(599);

  useEffect(() => { loadData(); }, []);

  const loadData = async () => {
    setLoading(true);
    try {
      const [usersRes, blackRes] = await Promise.all([
        axios.get(`${API}/auth/admin/users?secret=${ADMIN_SECRET}`),
        axios.get(`${API}/auth/admin/blacklist?secret=${ADMIN_SECRET}`),
      ]);
      const all = usersRes.data;
      setUsers(all);
      setBlacklist(blackRes.data);
      const paid     = all.filter(u => u.is_paid).length;
      const trial    = all.filter(u => !u.is_paid && u.days_left > 0).length;
      const expired  = all.filter(u => !u.is_paid && u.days_left <= 0).length;
      const expiring = all.filter(u => !u.is_paid && u.days_left <= 5 && u.days_left > 0).length;
      const premium  = all.filter(u => u.account_type === 'premium').length;
      const proOnly  = all.filter(u => u.account_type === 'pro' && u.is_paid).length;
      const revenue  = all.filter(u=>u.is_paid).reduce((s,u)=>s+(u.monthly_price||299),0);
      setStats({total:all.length,paid,trial,expired,expiring,premium,proOnly,revenue});
    } catch { setError('Data load failed! Secret key check பண்ணுங்கள்!'); }
    finally  { setLoading(false); }
  };

  const msg = (m, err=false) => {
    if(err){setError(m);setTimeout(()=>setError(''),4000);}
    else   {setSuccess(m);setTimeout(()=>setSuccess(''),3000);}
  };

  const activateUser = async (id, name) => {
    if (!window.confirm(`${name} activate பண்ணவா? (Pro)`)) return;
    try {
      await axios.put(`${API}/auth/admin/activate/${id}?secret=${ADMIN_SECRET}`);
      msg(`✅ ${name} activated as Pro!`); loadData();
    } catch { msg('Failed!', true); }
  };

  const openUpgrade = (user) => {
    setUpgradeUser(user);
    const cur = user.account_type || 'pro';
    if (cur === 'trial' || cur === 'pro') { setUpgradePlan('premium'); setUpgradePrice(599); }
    else { setUpgradePlan('business'); setUpgradePrice(999); }
    setShowUpgrade(true);
  };

  const confirmUpgrade = async () => {
    try {
      await axios.put(
        `${API}/auth/admin/upgrade-plan/${upgradeUser.id}?secret=${ADMIN_SECRET}`,
        { plan: upgradePlan, monthly_price: upgradePrice },
        { headers: {'Content-Type':'application/json'} }
      );
      msg(`✅ ${upgradeUser.name} → ${upgradePlan}! Rs.${upgradePrice}/mo`);
      setShowUpgrade(false); loadData();
    } catch(e){ msg(e.response?.data?.detail||'Failed!',true); }
  };

  const extendTrial = async (id, name) => {
    if (!window.confirm(`${name} 60 days extend?`)) return;
    try {
      await axios.put(`${API}/auth/admin/extend-trial/${id}?secret=${ADMIN_SECRET}&trial_days=60`);
      msg(`✅ ${name} = 60 days!`); loadData();
    } catch { msg('Failed!', true); }
  };

  const disableUser = async (id, name) => {
    const reason = window.prompt(`${name} disable reason:`);
    if (!reason) return;
    try {
      await axios.put(`${API}/auth/admin/disable/${id}?secret=${ADMIN_SECRET}&reason=${reason}`);
      msg(`❌ ${name} disabled!`); loadData();
    } catch { msg('Failed!', true); }
  };

  const removeBlacklist = async (id) => {
    if (!window.confirm('Remove?')) return;
    try {
      await axios.delete(`${API}/auth/admin/blacklist/${id}?secret=${ADMIN_SECRET}`);
      msg('✅ Removed!'); loadData();
    } catch { msg('Failed!', true); }
  };

  const sendWA = (phone, name, daysLeft, plan) => {
    const price = PLANS[plan]?.price || 299;
    const pname = PLANS[plan]?.name  || 'Pro';
    const m = daysLeft<=0
      ? `Anna ${name}! 😊\n\nJSMSTOCK trial முடிந்தது!\n${pname} = Rs.${price}/month\n\nUPI: ${YOUR_UPI}\n\nPay பண்ணி screenshot அனுப்புங்கள்! 🙏`
      : `Anna ${name}! 😊\n\n${daysLeft} நாள் மட்டும் மீதம்!\nRs.${price} pay பண்ணுங்கள்!\nUPI: ${YOUR_UPI}`;
    window.open(`https://wa.me/91${phone}?text=${encodeURIComponent(m)}`, '_blank');
  };

  const filtered = users.filter(u => {
    const q = search.toLowerCase();
    const m = u.name?.toLowerCase().includes(q)||u.email?.toLowerCase().includes(q)||
              u.shop_name?.toLowerCase().includes(q)||u.phone?.includes(q);
    if (filter==='paid')     return m && u.is_paid;
    if (filter==='pro')      return m && u.account_type==='pro' && u.is_paid;
    if (filter==='premium')  return m && u.account_type==='premium';
    if (filter==='business') return m && u.account_type==='business';
    if (filter==='trial')    return m && !u.is_paid && u.days_left>0;
    if (filter==='expiring') return m && !u.is_paid && u.days_left<=5 && u.days_left>0;
    if (filter==='expired')  return m && !u.is_paid && u.days_left<=0;
    if (filter==='inactive') return m && !u.is_active;
    return m;
  });

  const getStatus = (u) => {
    if (!u.is_active)     return {label:'Disabled',        color:'#95a5a6',bg:'#f0f0f0'};
    if (u.is_paid)        return {label:'Paid ✅',          color:'#27ae60',bg:'#e8f8f0'};
    if (u.days_left<=0)   return {label:'Expired ❌',       color:'#e74c3c',bg:'#fff0f0'};
    if (u.days_left<=5)   return {label:`⚠️ ${u.days_left}d`,color:'#e67e22',bg:'#fff5e6'};
    return {label:`Trial ${u.days_left}d`,                   color:'#3498db',bg:'#eaf4fb'};
  };

  if (loading) return (
    <div style={s.center}>
      <div style={s.lb}><h2 style={{color:'#2c3e50'}}>📦 JSMSTOCK Admin</h2><p>Loading...</p></div>
    </div>
  );

  return (
    <div style={s.page}>
      {/* Header */}
      <div style={s.header}>
        <div>
          <h1 style={s.htitle}>📦 JSMSTOCK Admin</h1>
          <p style={s.hsub}>உங்கள் கடை, உங்கள் கையில்!</p>
        </div>
        <div style={{display:'flex',gap:'10px'}}>
          <button style={s.refBtn} onClick={loadData}>🔄 Refresh</button>
          <button style={s.logBtn} onClick={()=>{
            sessionStorage.clear();
            if(onLogout) onLogout();
            window.location.href='/admin';
          }}>🚪 Logout</button>
        </div>
      </div>

      {success && <div style={s.sBox}>{success}</div>}
      {error   && <div style={s.eBox}>{error}
        <span style={{cursor:'pointer'}} onClick={()=>setError('')}> ✕</span>
      </div>}

      {/* Stats */}
      <div style={s.statsRow}>
        {[
          {label:'Total',    value:stats.total||0,   color:'#2c3e50',icon:'👥'},
          {label:'Paid All', value:stats.paid||0,    color:'#27ae60',icon:'✅'},
          {label:'⭐ Pro',   value:stats.proOnly||0, color:'#3498DB',icon:'⭐'},
          {label:'👑 Premium',value:stats.premium||0,color:'#C9A84C',icon:'👑'},
          {label:'Expiring', value:stats.expiring||0,color:'#e67e22',icon:'⚠️'},
          {label:'Expired',  value:stats.expired||0, color:'#e74c3c',icon:'❌'},
          {label:'Trial',    value:stats.trial||0,   color:'#3498db',icon:'⏳'},
          {label:'Revenue',  value:`Rs.${(stats.revenue||0).toLocaleString()}`,color:'#c9a84c',icon:'💰'},
        ].map((st,i)=>(
          <div key={i} style={{...s.statCard,borderTop:`4px solid ${st.color}`}}>
            <div style={{fontSize:'20px'}}>{st.icon}</div>
            <div style={{fontSize:'20px',fontWeight:'bold',color:st.color}}>{st.value}</div>
            <div style={{fontSize:'10px',color:'#666'}}>{st.label}</div>
          </div>
        ))}
      </div>

      {/* Tabs */}
      <div style={s.tabs}>
        {['users','blacklist'].map(t=>(
          <button key={t}
            style={{...s.tab,...(activeTab===t?s.tabA:{})}}
            onClick={()=>setActiveTab(t)}>
            {t==='users'?`👥 Users (${users.length})`:`🚫 Blacklist (${blacklist.length})`}
          </button>
        ))}
      </div>

      {activeTab==='users' && (<>
        <div style={s.searchRow}>
          <input style={s.si}
            placeholder="🔍 Name, email, shop, 📱 phone..."
            value={search} onChange={e=>setSearch(e.target.value)}/>
          <select style={s.fs} value={filter} onChange={e=>setFilter(e.target.value)}>
            <option value="all">All Users</option>
            <option value="paid">✅ Paid All</option>
            <option value="pro">⭐ Pro Only</option>
            <option value="premium">👑 Premium</option>
            <option value="business">🏢 Business</option>
            <option value="trial">⏳ Trial</option>
            <option value="expiring">⚠️ Expiring</option>
            <option value="expired">❌ Expired</option>
            <option value="inactive">🚫 Disabled</option>
          </select>
        </div>

        <div style={s.tableWrap}>
          <table style={s.table}>
            <thead>
              <tr style={s.thead}>
                <th style={s.th}>ID</th>
                <th style={s.th}>Name + Shop</th>
                {/* ✅ Mobile number column */}
                <th style={s.th}>Email + 📱 Mobile</th>
                <th style={s.th}>Status</th>
                <th style={s.th}>Plan</th>
                <th style={s.th}>Days</th>
                <th style={s.th}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length===0
                ? <tr><td colSpan={7} style={{textAlign:'center',padding:'30px',color:'#999'}}>
                    No users found!
                  </td></tr>
                : filtered.map((u,i)=>{
                  const st     = getStatus(u);
                  const plan   = u.account_type||'pro';
                  const planC  = PLANS[plan]||PLANS.pro;
                  const canUp  = u.is_paid && plan!=='business' && !u.is_staff;
                  return (
                    <tr key={u.id} style={{backgroundColor:i%2===0?'white':'#f8f9fa'}}>
                      <td style={s.td}>{u.id}</td>

                      <td style={s.td}>
                        <div style={{fontWeight:'bold',color:'#2c3e50'}}>
                          {u.name}
                          {u.is_staff && <span style={{
                            fontSize:'10px',background:'#EBF5FB',color:'#3498DB',
                            padding:'1px 6px',borderRadius:'4px',marginLeft:'6px',
                          }}>STAFF</span>}
                        </div>
                        <div style={{fontSize:'12px',color:'#666'}}>{u.shop_name}</div>
                      </td>

                      {/* ✅ Email + Mobile both showing */}
                      <td style={s.td}>
                        <div style={{fontSize:'12px',color:'#444'}}>{u.email}</div>
                        <div style={{fontSize:'13px',color:'#2c3e50',fontWeight:'600',marginTop:'3px'}}>
                          {u.phone
                            ? <span>📱 {u.phone}</span>
                            : <span style={{color:'#E74C3C',fontSize:'11px'}}>❌ No mobile</span>}
                        </div>
                      </td>

                      <td style={s.td}>
                        <span style={{...s.badge,color:st.color,backgroundColor:st.bg}}>
                          {st.label}
                        </span>
                      </td>

                      {/* ✅ Plan badge */}
                      <td style={s.td}>
                        <span style={{...s.badge,color:planC.color,backgroundColor:planC.bg,fontWeight:'700'}}>
                          {planC.name}
                        </span>
                        <div style={{fontSize:'11px',color:'#888',marginTop:'3px'}}>
                          Rs.{u.monthly_price||299}/mo
                        </div>
                      </td>

                      <td style={s.td}>
                        <span style={{fontSize:'13px',color:'#666'}}>
                          {u.is_paid?'∞':`${u.days_used||0}/${u.trial_days||30}`}
                        </span>
                      </td>

                      <td style={s.td}>
                        <div style={s.aRow}>
                          {!u.is_paid && (
                            <button style={s.bGreen}
                              onClick={()=>activateUser(u.id,u.name)}>
                              ✅ Activate
                            </button>
                          )}
                          {canUp && (
                            <button style={s.bGold}
                              onClick={()=>openUpgrade(u)}>
                              👑 Upgrade
                            </button>
                          )}
                          {!u.is_paid && (
                            <button style={s.bPurple}
                              onClick={()=>extendTrial(u.id,u.name)}>
                              ⏰ +60d
                            </button>
                          )}
                          {u.phone && !u.is_paid && (
                            <button style={s.bBlue}
                              onClick={()=>sendWA(u.phone,u.name,u.days_left,plan)}>
                              📱 Remind
                            </button>
                          )}
                          {u.is_active && !u.is_staff && (
                            <button style={s.bRed}
                              onClick={()=>disableUser(u.id,u.name)}>
                              🚫 Disable
                            </button>
                          )}
                        </div>
                      </td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
        <div style={{padding:'10px 15px',color:'#666',fontSize:'13px'}}>
          Showing {filtered.length} of {users.length} users
        </div>
      </>)}

      {activeTab==='blacklist' && (
        <div style={s.tableWrap}>
          {blacklist.length===0
            ? <div style={{textAlign:'center',padding:'40px',color:'#666'}}>
                No blacklisted users! 🎉
              </div>
            : <table style={s.table}>
                <thead>
                  <tr style={s.thead}>
                    {['ID','Email','Phone','Reason','Action'].map(h=>(
                      <th key={h} style={s.th}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {blacklist.map((e,i)=>(
                    <tr key={e.id} style={{backgroundColor:i%2===0?'white':'#f8f9fa'}}>
                      <td style={s.td}>{e.id}</td>
                      <td style={s.td}>{e.email||'—'}</td>
                      <td style={s.td}>{e.phone||'—'}</td>
                      <td style={s.td}><span style={{color:'#e74c3c'}}>{e.reason}</span></td>
                      <td style={s.td}>
                        <button style={s.bGreen} onClick={()=>removeBlacklist(e.id)}>
                          ✅ Remove
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>}
        </div>
      )}

      {/* Upgrade Modal */}
      {showUpgrade && upgradeUser && (
        <div style={s.mOverlay}
          onClick={e=>e.target===e.currentTarget&&setShowUpgrade(false)}>
          <div style={s.modal}>
            <h2 style={{margin:'0 0 12px',color:'#2C3E50'}}>👑 Plan Upgrade</h2>
            <p style={{color:'#666',marginBottom:'14px',fontSize:'14px'}}>
              <b>{upgradeUser.name}</b> ({upgradeUser.shop_name})<br/>
              Current: <b>{PLANS[upgradeUser.account_type||'pro']?.name||'Pro'}</b>
            </p>
            <div style={{display:'flex',gap:'10px',marginBottom:'14px',flexWrap:'wrap'}}>
              {Object.entries(PLANS)
                .filter(([id])=>id!=='trial'&&id!==(upgradeUser.account_type||'pro'))
                .map(([id,p])=>(
                  <div key={id}
                    onClick={()=>{setUpgradePlan(id);setUpgradePrice(p.price);}}
                    style={{
                      border:`2px solid ${upgradePlan===id?p.color:'#DDD'}`,
                      background:upgradePlan===id?p.bg:'white',
                      borderRadius:'10px',padding:'12px 16px',
                      cursor:'pointer',textAlign:'center',minWidth:'100px',
                    }}>
                    <div style={{fontWeight:'700',color:p.color}}>{p.name}</div>
                    <div style={{fontSize:'20px',fontWeight:'900',color:'#2C3E50'}}>Rs.{p.price}</div>
                    <div style={{fontSize:'11px',color:'#888'}}>/month</div>
                  </div>
                ))}
            </div>
            <label style={{fontSize:'12px',fontWeight:'700',color:'#666'}}>Price:</label>
            <input type="number" style={{width:'100%',padding:'10px',borderRadius:'8px',border:'1px solid #DDD',fontSize:'14px',boxSizing:'border-box',margin:'6px 0 14px'}}
              value={upgradePrice} onChange={e=>setUpgradePrice(Number(e.target.value))}/>
            <div style={{display:'flex',gap:'10px'}}>
              <button style={s.mCancel} onClick={()=>setShowUpgrade(false)}>Cancel</button>
              <button style={s.mConfirm} onClick={confirmUpgrade}>
                ✅ Upgrade to {PLANS[upgradePlan]?.name}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const s = {
  page:    {backgroundColor:'#f0f2f5',minHeight:'100vh',padding:'20px',fontFamily:'Arial,sans-serif'},
  center:  {display:'flex',alignItems:'center',justifyContent:'center',minHeight:'100vh'},
  lb:      {textAlign:'center',padding:'40px',backgroundColor:'white',borderRadius:'15px'},
  header:  {display:'flex',justifyContent:'space-between',alignItems:'center',backgroundColor:'#2c3e50',color:'white',padding:'20px 25px',borderRadius:'12px',marginBottom:'20px'},
  htitle:  {margin:0,fontSize:'24px'},
  hsub:    {margin:'5px 0 0',fontSize:'14px',opacity:0.8},
  refBtn:  {backgroundColor:'#c9a84c',color:'white',border:'none',padding:'10px 20px',borderRadius:'8px',cursor:'pointer',fontWeight:'bold'},
  logBtn:  {backgroundColor:'#e74c3c',color:'white',border:'none',padding:'10px 20px',borderRadius:'8px',cursor:'pointer',fontWeight:'bold'},
  sBox:    {backgroundColor:'#e8f8f0',border:'1px solid #27ae60',color:'#27ae60',padding:'12px 16px',borderRadius:'8px',marginBottom:'15px',fontWeight:'bold'},
  eBox:    {backgroundColor:'#fff0f0',border:'1px solid #e74c3c',color:'#e74c3c',padding:'12px 16px',borderRadius:'8px',marginBottom:'15px',display:'flex',justifyContent:'space-between'},
  statsRow:{display:'grid',gridTemplateColumns:'repeat(8,1fr)',gap:'10px',marginBottom:'20px'},
  statCard:{backgroundColor:'white',borderRadius:'10px',padding:'12px',textAlign:'center',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'},
  tabs:    {display:'flex',gap:'10px',marginBottom:'15px'},
  tab:     {padding:'10px 20px',border:'2px solid #ddd',borderRadius:'8px',cursor:'pointer',backgroundColor:'white',fontWeight:'bold',color:'#666'},
  tabA:    {borderColor:'#2c3e50',backgroundColor:'#2c3e50',color:'white'},
  searchRow:{display:'flex',gap:'10px',marginBottom:'15px'},
  si:      {flex:1,padding:'10px 15px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px'},
  fs:      {padding:'10px 15px',border:'1px solid #ddd',borderRadius:'8px',fontSize:'14px',cursor:'pointer',minWidth:'160px'},
  tableWrap:{backgroundColor:'white',borderRadius:'12px',overflow:'auto',boxShadow:'0 2px 8px rgba(0,0,0,0.08)'},
  table:   {width:'100%',borderCollapse:'collapse'},
  thead:   {backgroundColor:'#2c3e50'},
  th:      {padding:'12px 15px',textAlign:'left',color:'white',fontSize:'13px',fontWeight:'bold'},
  td:      {padding:'10px 15px',borderBottom:'1px solid #f0f0f0',fontSize:'13px',verticalAlign:'middle'},
  badge:   {padding:'3px 9px',borderRadius:'12px',fontSize:'11px',fontWeight:'bold'},
  aRow:    {display:'flex',gap:'5px',flexWrap:'wrap'},
  bGreen:  {backgroundColor:'#27ae60',color:'white',border:'none',padding:'5px 9px',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'bold'},
  bBlue:   {backgroundColor:'#3498db',color:'white',border:'none',padding:'5px 9px',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'bold'},
  bRed:    {backgroundColor:'#e74c3c',color:'white',border:'none',padding:'5px 9px',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'bold'},
  bGold:   {backgroundColor:'#C9A84C',color:'#2C3E50',border:'none',padding:'5px 9px',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'bold'},
  bPurple: {backgroundColor:'#9B59B6',color:'white',border:'none',padding:'5px 9px',borderRadius:'6px',cursor:'pointer',fontSize:'11px',fontWeight:'bold'},
  mOverlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.6)',zIndex:1000,display:'flex',alignItems:'center',justifyContent:'center',padding:'20px'},
  modal:   {background:'white',borderRadius:'16px',padding:'28px',maxWidth:'440px',width:'100%',boxShadow:'0 20px 60px rgba(0,0,0,0.3)'},
  mCancel: {flex:1,padding:'11px',borderRadius:'8px',border:'1px solid #DDD',background:'white',cursor:'pointer',fontWeight:'600',color:'#555'},
  mConfirm:{flex:2,padding:'11px',borderRadius:'8px',border:'none',background:'#C9A84C',color:'#2C3E50',cursor:'pointer',fontWeight:'700',fontSize:'14px'},
};

export default AdminDashboard;

